export function isBillingInvoiceMetadata(value) {
    if (!value || typeof value !== 'object')
        return false;
    const obj = value;
    return (typeof obj.subscriptionType === 'string' &&
        typeof obj.subscriptionId === 'number' &&
        typeof obj.billingCycleStart === 'string' &&
        typeof obj.billingCycleEnd === 'string');
}
export function isMembershipRecurringMetadata(value) {
    if (!value || typeof value !== 'object')
        return false;
    const obj = value;
    return (obj.type === 'membership_recurring' &&
        typeof obj.userMembershipId === 'string' &&
        typeof obj.membershipId === 'string' &&
        typeof obj.billingFrequency === 'string' &&
        typeof obj.billingCycleStart === 'string' &&
        typeof obj.billingCycleEnd === 'string' &&
        typeof obj.setupFee === 'number' &&
        typeof obj.isFirstInvoice === 'boolean' &&
        (obj.creditTracking !== undefined || obj.originalAmount !== undefined));
}
export function isPassPurchaseMetadata(value) {
    if (!value || typeof value !== 'object')
        return false;
    const obj = value;
    return (obj.type === 'pass_purchase' &&
        typeof obj.userPassId === 'string' &&
        typeof obj.passId === 'string' &&
        typeof obj.passName === 'string' &&
        typeof obj.validityDays === 'number' &&
        typeof obj.purchaseDate === 'string' &&
        (obj.expirationDate === null || typeof obj.expirationDate === 'string') &&
        (obj.creditTracking !== undefined || obj.originalAmount !== undefined));
}
export function isMembershipSetupMetadata(value) {
    if (!value || typeof value !== 'object')
        return false;
    const obj = value;
    return (obj.type === 'membership' &&
        typeof obj.membershipId === 'number' &&
        typeof obj.membershipName === 'string' &&
        typeof obj.price === 'number' &&
        typeof obj.setupFee === 'number' &&
        typeof obj.billingFrequency === 'string');
}
export function isWalkInBookingMetadata(value) {
    if (!value || typeof value !== 'object')
        return false;
    const obj = value;
    return (obj.type === 'booking_walkin' &&
        typeof obj.bayId === 'number' &&
        typeof obj.bayName === 'string' &&
        typeof obj.duration === 'number' &&
        typeof obj.hourlyRate === 'number');
}
export function isCustomLineItemMetadata(value) {
    if (!value || typeof value !== 'object')
        return false;
    const obj = value;
    if (!Array.isArray(obj.items)) {
        return false;
    }
    const itemsValid = obj.items.every((item) => {
        if (!item || typeof item !== 'object')
            return false;
        const itemObj = item;
        return (typeof itemObj.title === 'string' &&
            typeof itemObj.description === 'string' &&
            typeof itemObj.quantity === 'number' &&
            typeof itemObj.unitPrice === 'number' &&
            typeof itemObj.tax === 'number');
    });
    return itemsValid;
}
export function createBillingInvoiceMetadata(params) {
    return {
        subscriptionType: params.subscriptionType,
        subscriptionId: params.subscriptionId,
        billingCycleStart: params.billingCycleStart.toISOString(),
        billingCycleEnd: params.billingCycleEnd.toISOString(),
        ...(params.payerUserId != null && { payerUserId: params.payerUserId }),
    };
}
//# sourceMappingURL=billing.js.map